import React, { useState, useEffect } from 'react';
import DashTable from '../../components/DashboardTable';
import useApi from '../../api/useApi';

function Dashboard() {
  const [{ isLoading, isError, data }, getData] = useApi();
  const [stats, setStats] = useState();
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  // const orgId = JSON.parse(sessionStorage.user).organization.id;

  useEffect(() => {
    getData(`/stats`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setStats(data);
    }
  }, [isLoading, isError, data]);

  return (
    <div className="mt-16 md:mt-0 lg:m-8 static md:fixed bg-white w-full md:w-10/12 overflow-auto md:overflow-hidden dash_main">
      <div className="block md:flex m-auto" style={{ width: '96%' }}>
        <div className="h-36 flex-1 flex flex-wrap justify-around shadow-md my-2 bg-white items-center p-2 mr-2">
          <div className="w-2/5 mx-3 ">
            <span className="text-textBlue1 font-bold flex justify-between text-xl items-baseline">
              {stats?.organizationStats.Customer}{' '}
              <img src="assets/img/TotalCustomers.svg" className="w-6 h-auto mr-10" />
            </span>
            <span className="text-lightBlack font-semibold text-sm">Total Customers</span>
          </div>

          <div className="w-2/5 mx-3 ">
            <span className="text-textBlue1 font-bold flex justify-between text-xl items-baseline">
              {stats?.organizationStats.Project}{' '}
              <img src="assets/img/Total Projects.svg" className="w-4 h-auto mr-10" />
            </span>
            <span className="text-lightBlack font-semibold text-sm">Total Projects</span>
          </div>

          <div className="w-2/5 mx-3 ">
            <span className="text-textGreen1 font-bold flex justify-between text-xl items-baseline">
              {stats?.organizationStats.ActiveCustomer} <img src="assets/img/Arrows.svg" className="w-3 h-auto mr-10" />
            </span>
            <span className="text-lightBlack font-semibold text-sm">Active Customers</span>
          </div>

          <div className="w-2/5 mx-3 ">
            <span className="text-textGreen1 font-bold flex justify-between text-xl items-baseline">
              {stats?.organizationStats.ActiveProject} <img src="assets/img/Arrows.svg" className="w-3 h-auto mr-10" />
            </span>
            <span className="text-lightBlack font-semibold text-sm">Active Projects</span>
          </div>
        </div>

        <div className="h-36 md:w-box shadow-md my-2 bg-white flex flex-wrap flex-col justify-center p-4 mr-2">
          <div className="flex justify-between w-full">
            <div className="flex flex-col">
              <span className="text-textBlue2 font-bold text-xl ">{stats?.totalDevices.BLE_GW}</span>
              <span className="text-textBlue2 font-semibold text-sm ">Gateways</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textGreen2 font-bold text-xl ">{stats?.totalDevices.BLE_TAG}</span>
              <span className="text-textGreen2 font-semibold text-sm ">BLEs</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textBlue3 font-bold text-xl ">{stats?.totalDevices.CATM1_TAG}</span>
              <span className="text-textBlue3 font-semibold text-sm ">CatM1s</span>
            </div>
          </div>
          <span className="text-lightBlack font-semibold text-md pt-4">Manufactured Devices</span>
        </div>

        <div className="h-36 md:w-box shadow-md my-2 bg-white flex flex-wrap flex-col justify-center p-4 mr-2">
          <div className="flex justify-between w-full">
            <div className="flex flex-col">
              <span className="text-textBlue2 font-bold text-xl ">{stats?.assignedDevices.BLE_GW}</span>
              <span className="text-textBlue2 font-semibold text-sm ">Gateways</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textGreen2 font-bold text-xl ">{stats?.assignedDevices.BLE_TAG}</span>
              <span className="text-textGreen2 font-semibold text-sm ">BLEs</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textBlue3 font-bold text-xl ">{stats?.assignedDevices.CATM1_TAG}</span>
              <span className="text-textBlue3 font-semibold text-sm ">CatM1s</span>
            </div>
          </div>
          <span className="text-lightBlack font-semibold text-md pt-4">Assigned Devices</span>
        </div>

        <div className="h-36 md:w-box shadow-md my-2 bg-white flex flex-wrap flex-col justify-center p-4">
          <div className="flex justify-between w-full">
            <div className="flex flex-col">
              <span className="text-textBlue2 font-bold text-xl ">
                {stats?.totalDevices.BLE_GW - stats?.assignedDevices.BLE_GW}
              </span>
              <span className="text-textBlue2 font-semibold text-sm ">Gateways</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textGreen2 font-bold text-xl ">
                {stats?.totalDevices.BLE_TAG - stats?.assignedDevices.BLE_TAG}
              </span>
              <span className="text-textGreen2 font-semibold text-sm ">BLEs</span>
            </div>
            <div className="flex flex-col">
              <span className="text-textBlue3 font-bold text-xl ">
                {stats?.totalDevices.CATM1_TAG - stats?.assignedDevices.CATM1_TAG}
              </span>
              <span className="text-textBlue3 font-semibold text-sm ">CatM1s</span>
            </div>
          </div>
          <span className="text-lightBlack font-semibold text-md pt-4">Inventory</span>
        </div>
      </div>

      <DashTable />
    </div>
  );
}

export default Dashboard;
